import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3d8856f9")

_pushScopeId("data-v-3d8856f9")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "pi pi-breadcrumb-chevron pi-chevron-right" }, null, -1)
const _hoisted_4 = { class: "header-path-link" }
const _hoisted_5 = { class: "folder-list" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", {
  class: "bx bx-sm bxs-folder p-mr-2",
  style: {"color":"var(--folder-color)"}
}, null, -1)
const _hoisted_7 = { style: {"margin":"0 auto"} }
const _hoisted_8 = { class: "footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "header", {
        navigate: _ctx.navigate,
        current: _ctx.current
      }, () => [
        (_ctx.current)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.current.folderPath, (item, idx) => {
                return (_openBlock(), _createBlock(_Fragment, {
                  key: item.id
                }, [
                  _createVNode("span", {
                    class: "header-path-link",
                    onClick: ($event: any) => (_ctx.navigate(idx))
                  }, _toDisplayString(item.name), 9, ["onClick"]),
                  _hoisted_3
                ], 64))
              }), 128)),
              _createVNode("span", _hoisted_4, _toDisplayString(_ctx.current.name), 1)
            ], 64))
          : _createCommentVNode("", true)
      ], true)
    ]),
    _createVNode("ul", _hoisted_5, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.children, (child, idx) => {
        return (_openBlock(), _createBlock("li", {
          class: { 'disabled-child': _ctx.disabled[idx] },
          key: child.id,
          onClick: ($event: any) => (_ctx.navigate(child))
        }, [
          _hoisted_6,
          _createVNode("span", null, _toDisplayString(child.name), 1),
          (!_ctx.disabled[idx])
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "p-button-rounded p-button-secondary p-button-text",
                icon: "pi pi-angle-right",
                onClick: ($event: any) => (_ctx.navigate(child))
              }, null, 8, ["onClick"]))
            : (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                class: "p-button-rounded p-button-text"
              }))
        ], 10, ["onClick"]))
      }), 128)),
      (_ctx.hasMoreChildren)
        ? (_openBlock(), _createBlock("li", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadMore()))
          }, [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_Button, {
                class: "p-button-text",
                label: _ctx.$t('button.more')
              }, null, 8, ["label"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_8, [
      _renderSlot(_ctx.$slots, "footer", {
        cancel: _ctx.cancel,
        select: _ctx.select
      }, () => [
        _createVNode(_component_Button, {
          class: "p-button-text",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancel()))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          class: "p-button",
          disabled: _ctx.selectionDisabled,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.select()))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("button.select")), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ], true)
    ])
  ]))
})